import { render } from "./project-attribute.html?vue&type=template&id=d63b202e&scoped=true&ts=true"
import script from "./project-attribute.ts?vue&type=script&lang=ts"
export * from "./project-attribute.ts?vue&type=script&lang=ts"

import "./project-attribute.scss?vue&type=style&index=0&id=d63b202e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63b202e"]])

export default __exports__